// extracted by mini-css-extract-plugin
export default {"wrapper":"IntroRow_wrapper__a4Rlf","row":"IntroRow_row__fC1qh","rowRev":"IntroRow_rowRev__Al+9x"};